
import { isString } from "angular";
import { AbstractAccessorService } from "../../common/data-access/abstract-accessor.service";
import { IDataAccessor } from "../../common/data-access/data-accessor";
import { Token } from "../../common/data-access/model/token";
import { ProductInstance } from "../../dto/product-instance";
import { IInstanceService } from "./instance-rest";
import { ActionKey } from "./instance-rest.config";

export class InstanceService extends AbstractAccessorService<any> implements IInstanceService {
    public readonly $name: string = "instanceService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<any>) {
        super();
    }



    public updateOrder(orderId: string, wcOrderItemId: string, instance: ProductInstance, token: Token, rootPath: string): any {
        if (orderId && wcOrderItemId && instance && token && rootPath &&instance._id) {
            if(!isString(orderId)){
                orderId = String(orderId);
            }
            else if (!isString(wcOrderItemId)) {
                wcOrderItemId = String(wcOrderItemId);
            }
            else if (!isString(instance._id)) {
                instance._id = String(instance._id);
            }
        }else{
            return alert("parameter error");
        }
        return this.$accessor<any, {}, ActionKey>(this.$name, "updateOrder", {
            data: {
                "line_items": [{
                    "id": wcOrderItemId,
                    "meta_data": [
                        {
                            "key": "qpson_product_instance_id",
                            "value": instance._id,
                            "display_key": "qpson_product_instance_id",
                            "display_value": instance._id
                        },
                        {
                            "key": "qpson_thumbnail",
                            "value": rootPath + "/file/file/composingPreview/" + instance.thumbnail,
                            "display_key": "qpson_thumbnail",
                            "display_value": rootPath + "/file/file/composingPreview/" + instance.thumbnail,
                        }
                    ]
                }
                ]
            },
            headers: {
                Authorization: token.token_type + ' ' + token.access_token,
            },
            parameter: {
                orderId: orderId
            }
        })

    }
}
